import { DeckCode } from '../../shared/index.js';
import { initRound } from '../state/round.js';
export const defaultOptions = {
    rounds: 12,
    deckCode: DeckCode.TarotSW,
};
export function init(players, hostId, options = defaultOptions) {
    const deckCode = options.deckCode;
    return {
        deckCode: deckCode,
        players,
        roundsToPlay: options.rounds,
        completedRounds: [],
        currentRound: initRound(deckCode, players, 1, hostId),
    };
}
//# sourceMappingURL=init.js.map